<template>
  <v-col class="form-outline">
    <form-legend :field="field" />
    <v-text-field
      :label="label"
      v-model="streetValue"
      :rules="getFieldRules({ required: field.required })"
      :readonly="readonly"
      v-bind="darkOrLightMode"
      color="primary-action"
    />
    <v-row>
      <v-col cols="3">
        <v-text-field
          :label="'PLZ' + (field.required ? '*' : '')"
          v-model="zipValue"
          :rules="getFieldRules({ required: field.required })"
          :readonly="readonly"
          v-bind="darkOrLightMode"
          color="primary-action"
        />
      </v-col>
      <v-col>
        <v-text-field
          :label="'Ort' + (field.required ? '*' : '')"
          v-model="cityValue"
          :rules="getFieldRules({ required: field.required })"
          :readonly="readonly"
          v-bind="darkOrLightMode"
          color="primary-action"
        />
      </v-col>
    </v-row>
    <legend v-html="field.field_options.description" :class="'v-label theme--' + mode" />
  </v-col>
</template>

<script>
import formsMixin from '../formsMixin';
import FormLegend from '@/modules/forms/FormLegend.vue';

export default {
  components: { FormLegend },
  mixins: [formsMixin],
  props: {
    field: { type: Object, required: true },
    formModel: { type: Object, required: true },
    mediasModel: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    mode: { type: String, default: 'light' },
  },
  data() {
    return {
      streetValue: this.formModel[this.field.cid + '_Strasse'] ? this.formModel[this.field.cid + '_Strasse'] : '',
      zipValue: this.formModel[this.field.cid + '_PLZ'] ? this.formModel[this.field.cid + '_PLZ'] : '',
      cityValue: this.formModel[this.field.cid + '_Ort'] ? this.formModel[this.field.cid + '_Ort'] : '',
    };
  },
  computed: {
    label() {
      return (this.$te('street') ? this.$t('street') : 'Strasse / Nr.') + (this.field.required ? '*' : '');
    },
  },
  watch: {
    streetValue(newValue) {
      this.$emit('formUpdated', this.field.cid + '_Strasse', newValue);
    },
    zipValue(newValue) {
      this.$emit('formUpdated', this.field.cid + '_PLZ', newValue);
    },
    cityValue(newValue) {
      this.$emit('formUpdated', this.field.cid + '_Ort', newValue);
    },
    formModel(newValue) {
      const street = newValue[this.field.cid + '_Strasse'] ? newValue[this.field.cid + '_Strasse'] : '';
      const zip = newValue[this.field.cid + '_PLZ'] ? newValue[this.field.cid + '_PLZ'] : '';
      const city = newValue[this.field.cid + '_Ort'] ? newValue[this.field.cid + '_Ort'] : '';
      if (this.streetValue != street) {
        this.streetValue = street;
      }
      if (this.zipValue != zip) {
        this.zipValue = zip;
      }
      if (this.cityValue != city) {
        this.cityValue = city;
      }
    },
  },
};
</script>
